(function() {

  /* --- TOAST NOTIFICATION --- */
  function csrToast(msg) {
    let t = document.getElementById('csr-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'csr-toast';
      t.style.cssText = [
        'position:fixed',
        'bottom:28px',
        'right:28px',
        'background:#fff',
        'color:#000',
        'padding:14px 22px',
        'font-family:Inter,sans-serif',
        'font-size:12px',
        'letter-spacing:1px',
        'text-transform:uppercase',
        'z-index:9999',
        'opacity:0',
        'transform:translateY(12px)',
        'transition:opacity 0.3s ease,transform 0.3s ease',
        'pointer-events:none',
        'max-width:280px'
      ].join(';');
      document.body.appendChild(t);
    }
    t.textContent = msg;
    requestAnimationFrame(() => {
      t.style.opacity = '1';
      t.style.transform = 'translateY(0)';
    });
    clearTimeout(t._timer);
    t._timer = setTimeout(() => {
      t.style.opacity = '0';
      t.style.transform = 'translateY(12px)';
    }, 2800);
  }

  /* --- CART DRAWER INITIALIZATION --- */
  if (window.__csrCartInit) return;
  window.__csrCartInit = true;

  const csrDrawer  = document.getElementById('csr-drawer');
  const csrOverlay = document.getElementById('csr-overlay');
  const csrClose   = document.getElementById('csr-close');

  if (csrDrawer)  document.body.appendChild(csrDrawer);
  if (csrOverlay) document.body.appendChild(csrOverlay);

  // Hide duplicate items from double-rendered layouts
  document.querySelectorAll('#csr-drawer, #csr-overlay').forEach(el => {
    if (el !== csrDrawer && el !== csrOverlay) {
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('pointer-events', 'none', 'important');
    }
  });

  const allHeaders = document.querySelectorAll('.caesura-header');
  allHeaders.forEach((h, index) => {
    if (index === 0) {
      h.style.removeProperty('display');
      return;
    }
    h.style.setProperty('display', 'none', 'important');
  });

  /* --- PRODUCT PAGE HEADER: BLACK BG + HOME ICON --- */
  const mainEl = document.getElementById('MainContent');
  const isProductPage = mainEl && (mainEl.dataset.template || '').startsWith('product');
  const globalHeader = allHeaders[0];

  if (isProductPage && globalHeader) {
    // Solid black header on product page
    globalHeader.style.setProperty('background', '#000', 'important');
    globalHeader.style.setProperty('backdrop-filter', 'none', 'important');

    // Inject home icon into left-nav, before About link
    const leftNav = globalHeader.querySelector('.left-nav, .caesura-nav');
    if (leftNav && !leftNav.querySelector('.csr-home-icon')) {
      const homeLink = document.createElement('a');
      homeLink.href = '/';
      homeLink.className = 'csr-home-icon';
      homeLink.setAttribute('aria-label', 'Home');
      homeLink.style.cssText = 'display:flex;align-items:center;color:#fff;text-decoration:none;opacity:0.85;transition:opacity 0.2s';
      homeLink.onmouseenter = () => homeLink.style.opacity = '1';
      homeLink.onmouseleave = () => homeLink.style.opacity = '0.85';
      homeLink.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 9.5L12 3l9 6.5V21a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.5z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>';
      leftNav.insertBefore(homeLink, leftNav.firstChild);
    }
  }

  function csrApply(el, styles) {
    Object.entries(styles).forEach(([k, v]) => el.style.setProperty(k, v, 'important'));
  }

  function openDrawer() {
    if (!csrDrawer) return;
    csrApply(csrDrawer, {
      'position':       'fixed',
      'top':            '0',
      'right':          '0',
      'bottom':         '0',
      'width':          '430px',
      'max-width':      '100vw',
      'height':         '100vh',
      'background':     '#0a0a0a',
      'z-index':        '2147483647',
      'padding':        '40px',
      'display':        'flex',
      'flex-direction': 'column',
      'overflow-y':     'auto',
      'border-left':    '1px solid rgba(255,255,255,0.08)',
      'transform':      'none',
      'visibility':     'visible',
      'opacity':        '1',
      'pointer-events': 'auto'
    });

    csrApply(csrOverlay, {
      'position':       'fixed',
      'top':            '0',
      'left':           '0',
      'right':          '0',
      'bottom':         '0',
      'background':     'rgba(0,0,0,0.55)',
      'z-index':        '2147483646',
      'display':        'block',
      'visibility':     'visible',
      'opacity':        '1',
      'pointer-events': 'auto'
    });

    document.body.style.setProperty('overflow', 'hidden', 'important');
  }

  function closeDrawer() {
    if (!csrDrawer) return;
    csrApply(csrDrawer, { 'right': '-450px', 'pointer-events': 'none' });
    csrApply(csrOverlay, { 'opacity': '0', 'pointer-events': 'none' });
    document.body.style.removeProperty('overflow');
    setTimeout(() => csrApply(csrOverlay, { 'display': 'none' }), 420);
  }

  if (csrClose)   csrClose.addEventListener('click', closeDrawer);
  if (csrOverlay) csrOverlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });

  /* --- EVENT DELEGATION --- */
  document.addEventListener('click', async function csrDelegate(e) {
    // Open cart
    if (e.target.closest('[data-open-cart]')) {
      e.preventDefault();
      CAESURA_CART.open();
      return;
    }

    // Smooth scroll
    const scrollEl = e.target.closest('[data-scroll-to]');
    if (scrollEl) {
      e.preventDefault();
      const targetId = scrollEl.dataset.scrollTo;
      const main = document.getElementById('MainContent') || document.body;
      const target = main.querySelector('#' + targetId);
      if (target) {
        const hdr = document.querySelector('.caesura-header');
        window.scrollTo({ top: target.offsetTop - (hdr ? hdr.offsetHeight : 80), behavior: 'smooth' });
      }
      return;
    }

    // Add to cart (homepage style)
    const atcBtn = e.target.closest('[data-atc]');
    if (atcBtn && !atcBtn.disabled) {
      const selId = atcBtn.dataset.select;
      const main = document.getElementById('MainContent') || document.body;
      const sel = main.querySelector('#' + selId) || document.getElementById(selId);
      if (!sel) return;
      const variantId = parseInt(sel.value);
      atcBtn.textContent = 'Adding...';
      atcBtn.disabled = true;
      try {
        const added = await CAESURA_CART.add(variantId);
        csrToast((added.product_title || 'Item') + ' added to cart');
        atcBtn.textContent = '✓ Added';
        setTimeout(() => { atcBtn.textContent = 'Add to Cart'; atcBtn.disabled = false; }, 1600);
        CAESURA_CART.open();
      } catch(err) {
        csrToast(err.message || 'Could not add to cart');
        atcBtn.textContent = 'Add to Cart';
        atcBtn.disabled = false;
      }
      return;
    }

    // Cart Qty changes
    const qtyBtn = e.target.closest('.crt-qty-btn');
    if (qtyBtn) {
      const line = parseInt(qtyBtn.dataset.line);
      const qty  = parseInt(qtyBtn.dataset.qty);
      const updated = await CAESURA_CART.change(line, qty);
      CAESURA_CART.render(updated);
      return;
    }

    // Cart Remove
    const rmBtn = e.target.closest('.crt-remove');
    if (rmBtn) {
      const line = parseInt(rmBtn.dataset.line);
      const updated = await CAESURA_CART.change(line, 0);
      CAESURA_CART.render(updated);
      return;
    }
  });

  /* --- CAESURA AJAX CART SYSTEM --- */
  const CAESURA_CART = {
    fmt(cents) {
      const n = Number(cents);
      if (isNaN(n)) return '₹—';
      return '₹' + (n / 100).toLocaleString('en-IN', { minimumFractionDigits: 0 });
    },

    async get() {
      const r = await fetch('/cart.js');
      return r.json();
    },

    async add(variantId, qty = 1) {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      });
      if (!r.ok) {
        const err = await r.json().catch(() => ({}));
        throw new Error(err.description || err.message || 'Could not add to cart');
      }
      return r.json();
    },

    async change(line, qty) {
      const r = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity: qty })
      });
      if (!r.ok) {
        const err = await r.json().catch(() => ({}));
        const msg = err.description || err.message || 'Could not update quantity';
        csrToast(msg);
        return this.get();
      }
      return r.json();
    },

    render(cart) {
      const itemsEl    = document.getElementById('caesura-cart-items');
      const emptyEl    = document.getElementById('csr-empty');
      const subtotalEl = document.getElementById('caesura-cart-subtotal');
      const checkoutBtn= document.getElementById('caesura-checkout-btn');
      if (!itemsEl) return;
      if (!cart || cart.status) return;

      if (cart.item_count === 0) {
        itemsEl.innerHTML = '';
        if (emptyEl) emptyEl.style.display = 'block';
        if (subtotalEl) subtotalEl.style.display = 'none';
        if (checkoutBtn) { checkoutBtn.style.opacity = '0.4'; checkoutBtn.style.pointerEvents = 'none'; }
        return;
      }

      if (emptyEl) emptyEl.style.display = 'none';
      if (subtotalEl) {
        subtotalEl.style.display = 'flex';
        subtotalEl.innerHTML = `<span>Subtotal</span><span>${this.fmt(cart.total_price)}</span>`;
      }
      if (checkoutBtn) {
        checkoutBtn.style.opacity = '1';
        checkoutBtn.style.pointerEvents = 'auto';
      }

      itemsEl.innerHTML = cart.items.map((item, idx) => `
        <div data-line="${idx + 1}" style="display:flex;gap:16px;padding:20px 0;border-bottom:1px solid rgba(255,255,255,0.06);">
          <img src="${item.image}" alt="${item.product_title}" style="width:70px;height:88px;object-fit:cover;flex-shrink:0;border:1px solid rgba(255,255,255,0.06);">
          <div style="flex:1;display:flex;flex-direction:column;gap:5px;">
            <div style="font-size:12px;letter-spacing:1px;text-transform:uppercase;color:#fff;font-family:Inter,sans-serif;">${item.product_title}</div>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<div style="font-size:11px;color:#777;letter-spacing:0.5px;font-family:Inter,sans-serif;">${item.variant_title}</div>` : ''}
            <div style="font-size:12px;color:rgba(255,255,255,0.7);margin-top:4px;font-family:Inter,sans-serif;">${this.fmt(item.final_line_price)}</div>
            <div style="display:flex;align-items:center;gap:10px;margin-top:8px;">
              <button class="crt-qty-btn" data-line="${idx + 1}" data-qty="${item.quantity - 1}" style="background:none;border:1px solid rgba(255,255,255,0.14);color:#d9d9d9;width:26px;height:26px;cursor:pointer;font-size:13px;display:flex;align-items:center;justify-content:center;font-family:Inter,sans-serif;">−</button>
              <span style="color:#fff;font-size:13px;font-family:Inter,sans-serif;">${item.quantity}</span>
              <button class="crt-qty-btn" data-line="${idx + 1}" data-qty="${item.quantity + 1}" style="background:none;border:1px solid rgba(255,255,255,0.14);color:#d9d9d9;width:26px;height:26px;cursor:pointer;font-size:13px;display:flex;align-items:center;justify-content:center;font-family:Inter,sans-serif;">+</button>
              <button class="crt-remove" data-line="${idx + 1}" style="background:none;border:none;color:rgba(255,255,255,0.35);cursor:pointer;font-size:11px;margin-left:auto;font-family:Inter,sans-serif;">Remove</button>
            </div>
          </div>
        </div>
      `).join('');
    },

    async open() {
      openDrawer();
      const cart = await this.get();
      this.render(cart);
    }
  };

  window.CAESURA_CART = CAESURA_CART;

  /* --- PARALLAX EFFECT --- */
  const csrWrap1 = document.getElementById('pcard-wrap-1');
  const csrWrap2 = document.getElementById('pcard-wrap-2');
  const csrWrap3 = document.getElementById('pcard-wrap-3');
  const csrWrap4 = document.getElementById('pcard-wrap-4');
  const csrSection = document.getElementById('parallax-products');

  function updateParallax() {
    if (!csrSection || !csrWrap1 || !csrWrap2) return;
    const rect = csrSection.getBoundingClientRect();
    const progress = -rect.top;
    if (progress > -window.innerHeight && progress < rect.height + window.innerHeight) {
      csrWrap1.style.transform = `translateY(${progress * 0.08}px)`;
      csrWrap2.style.transform = `translateY(${80 + progress * 0.14}px)`;
      if (csrWrap3) csrWrap3.style.transform = `translateY(${progress * 0.06}px)`;
      if (csrWrap4) csrWrap4.style.transform = `translateY(${80 + progress * 0.11}px)`;
    }
  }

  window.addEventListener('scroll', updateParallax, { passive: true });
  updateParallax();

  /* --- 3D TILT EFFECT --- */
  document.querySelectorAll('.parallax-card').forEach(card => {
    card.addEventListener('mousemove', e => {
      const r  = card.getBoundingClientRect();
      const dx = (e.clientX - r.left - r.width  / 2) / (r.width  / 2);
      const dy = (e.clientY - r.top  - r.height / 2) / (r.height / 2);
      card.style.transform = `perspective(900px) rotateY(${dx * 11}deg) rotateX(${-dy * 9}deg) scale3d(1.02,1.02,1.02)`;
    });
    card.addEventListener('mouseleave', () => {
      card.style.transform = 'perspective(900px) rotateY(0deg) rotateX(0deg) scale3d(1,1,1)';
    });
  });

  /* --- REVEAL ON SCROLL --- */
  const csrReveal = document.querySelectorAll('.reveal-card');
  function revealOnScroll() {
    csrReveal.forEach(card => {
      if (card.getBoundingClientRect().top < window.innerHeight - 100) card.classList.add('active');
    });
  }
  window.addEventListener('scroll', revealOnScroll);
  revealOnScroll();

  /* --- EMAIL SIGNUP --- */
  const csrEmailForm = document.getElementById('caesura-email-form');
  if (csrEmailForm) {
    csrEmailForm.addEventListener('submit', async e => {
      e.preventDefault();
      const inp = document.getElementById('caesura-email-input');
      const ok  = document.getElementById('email-success');
      const err = document.getElementById('email-error');
      if (ok) ok.className = 'email-msg';
      if (err) err.className = 'email-msg';
      const body = new FormData();
      body.append('form_type', 'customer');
      body.append('utf8', '✓');
      body.append('contact[email]', inp.value);
      body.append('contact[tags]', 'newsletter');
      try {
        const r = await fetch('/contact', { method: 'POST', body });
        if (r.ok) { if (ok) ok.className = 'email-msg success'; inp.value = ''; }
        else { if (err) err.className = 'email-msg error'; }
      } catch { if (err) err.className = 'email-msg error'; }
    });
  }

  /* --- NATIVE CART INTEGRATION --- */
  document.addEventListener('cart:update', async (e) => {
    // Sync updates made from the native product forms
    if (e.detail && e.detail.data && e.detail.data.source === 'product-form-component') {
      try {
        const cart = e.detail.resource || await CAESURA_CART.get();
        CAESURA_CART.render(cart);
        // Open cart drawer instead of showing a toast
        CAESURA_CART.open();
      } catch (err) {
        console.warn('[CSR] Global cart sync failed', err);
      }
    }
  });

})();
